(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mega-field-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bind = (root) => {
      root.querySelectorAll('[data-mega-field-review]').forEach((review) => {
        if (review.dataset.bound) return;
        review.dataset.bound = 'true';
        review.addEventListener('toggle', () => {
          const frame = review.querySelector('iframe[data-video-src]');
          if (!frame) return;
          if (review.open) frame.src = frame.dataset.videoSrc;
          else frame.removeAttribute('src');
        });
      });
    };
    bind(document);
    document.addEventListener('shopify:section:load', (event) => bind(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-video"] && !Shopify.designMode) return;
  try {
    
function initMegaVideo(root){
  root.querySelectorAll('[data-mega-section]').forEach(section=>{
    if(section.dataset.ready)return;section.dataset.ready='true';
    const video=section.querySelector('video'),button=section.querySelector('.zm-video__toggle');
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    const automatic=video.hasAttribute('data-auto-preview')&&!reduced.matches&&!navigator.connection?.saveData;
    let visible=false,userPaused=false,systemPause=false,manual=false,started=false;
    const reached=new Set();
    function track(action,percent){
      if(!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.())return;
      const payload={event:'mega_video_engagement',video_name:video.getAttribute('aria-label'),video_action:action,playback_type:manual?'manual':'autoplay',video_percent:percent||0};
      if(Array.isArray(window.dataLayer))window.dataLayer.push(payload);
    }
    function load(){
      const selected=window.matchMedia('(max-width: 749px)').matches?(video.dataset.mobileSource||video.dataset.source):video.dataset.source;
      if(video.getAttribute('src')!==selected)video.src=selected;
    }
    function play(){
      load();
      video.muted=true;
      video.playsInline=true;
      if(video.error){
        video.src=video.dataset.source||video.getAttribute('src');
        video.load();
      }
      const attempt=video.play();
      if(attempt&&typeof attempt.catch==='function')attempt.catch(()=>{
        if(button)button.textContent=button.dataset.playLabel;
      });
    }
    function pause(){if(!video.paused){systemPause=true;video.pause();}}
    video.addEventListener('play',()=>{if(button)button.textContent=button.dataset.pauseLabel;if(!started){track('start');started=true;}});
    video.addEventListener('pause',()=>{if(button)button.textContent=button.dataset.playLabel;if(systemPause)systemPause=false;else userPaused=true;});
    video.addEventListener('pointerdown',()=>{manual=true;userPaused=false;});
    video.addEventListener('keydown',()=>{manual=true;userPaused=false;});
    video.addEventListener('timeupdate',()=>{if(!video.duration)return;const percent=100*video.currentTime/video.duration;[25,50,90].forEach(p=>{if(percent>=p&&!reached.has(p)){reached.add(p);track('progress',p);}});});
    video.addEventListener('ended',()=>track('complete',100));
    button?.addEventListener('click',()=>{manual=true;if(video.paused){userPaused=false;play();}else{userPaused=true;video.pause();}});
    section.querySelector('.zm-video__cta')?.addEventListener('click',()=>track('product_click'));
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.35;if(visible){load();if(automatic&&!userPaused&&!document.hidden)play();}else pause();},{threshold:.35});
    observer.observe(video);
    document.addEventListener('visibilitychange',()=>{if(document.hidden)pause();else if(visible&&automatic&&!userPaused)play();});
    reduced.addEventListener('change',event=>{if(event.matches){userPaused=true;pause();}});
  });
}
initMegaVideo(document);
document.addEventListener('shopify:section:load',event=>initMegaVideo(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specifications"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('shopify:block:select', (event) => {
    const table = event.target.closest('.product-specifications__groups');
    if (table) table.closest('details').open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
